import React from 'react'

interface TextInputProps {
	value: string
	onChange: (value: string) => void
	placeholder?: string
	type?: string
	className?: string
}

export default function TextInput({ value, onChange, placeholder, type = 'text', className }: TextInputProps) {
	return (
		<input
			type={type}
			value={value || ''}
			onChange={(e) => onChange(e.target.value)}
			className={
				className ||
				'w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-xs'
			}
			placeholder={placeholder}
		/>
	)
}


